import { createAction, props } from '@ngrx/store';
import { MuseumCollection } from '../../models';

export const LoadMuseumCollections = createAction('[Museum] Load Museum Collections');
export const LoadMuseumCollectionsSuccess = createAction(
  '[Museum] Load Museum Collections Success',
  props<{ collections: MuseumCollection[] }>()
);
export const LoadMuseumCollectionsFail = createAction('[Museum] Load Museum Collections Fail', props<{ error: any }>());

export const LoadMuseumCollectionById = createAction('[Museum] Load Museum Collection by Id', props<{ id: number }>());
export const LoadMuseumCollectionByIdSuccess = createAction(
  '[Museum] Load Museum Collection by Id Success',
  props<{ collection: MuseumCollection }>()
);
export const LoadMuseumCollectionByIdFail = createAction('[Museum] Load Museum Collection by Id Fail', props<{ id: number; error: any }>());
